<template>
  <div
    class="prospect-details"
    :style="{ '--prospect-header-height': `${$vuetify.application.top}px` }">
    <gat-form
      v-if="hasAgencySetting('TAB_PROSPECTS') && applicationStore.user.internal"
      v-model="isValid"
      class="prospect-form"
      ref="form"
      :readonly="!applicationStore.userRight('PRO.EDIT')"
      :isLoading="isLoading">
      <v-layout wrap class="prospect-header">
        <gat-edit label="Name" v-model="prospectItem.CHO_NAME" :disabled="true" :maxChars="100" />
        <gat-edit label="Subject" v-model="prospectItem.CHO_SUBJECT" :disabled="true" :maxChars="500" />
      </v-layout>
      <div class="ml-2">
        <gat-button-menu
          caption="Text templates"
          :menuItems="prospectTemplates"
          :disabled="prospectTemplates && prospectTemplates.length == 0"
          @menuItemClick="onProspectTemplateClick"
          @subMenuItemClick="onProspectTemplateClick"
          icon="mdi-file-multiple" />
      </div>
      <GatFieldSpacer></GatFieldSpacer>
      <v-layout wrap class="prospect-instructions">
        <gat-edit
          class="prospect-instruction-field"
          v-model="prospectItem.CHO_INSTRUCTIONS"
          :rows="1"
          :auto-grow="false"
          label="Details"
          size="xs12"
          :maxChars="10000"
          ref="instructions" />
        <gat-edit
          class="prospect-instruction-field"
          v-model="prospectHintAndInstructions"
          :rows="1"
          :auto-grow="false"
          label="Hint and instructions"
          :readonly="true"
          :disabled="true"
          size="xs12"
          :maxChars="10000" />
      </v-layout>

      <!-- <span class="ml-3 caption">Updated: {{ prospectItem.Updated }} ({{ prospectItem.CHO_LAST_UPDATED_BY }})</span> -->
      <gat-bottom-panel
        :orgValue="orgProspectItem"
        :newValue="prospectItem"
        :itemDescription="'prospect item '"
        :saveBtn="true"
        :deleteBtn="false"
        :buttonsEnabled="!saving"
        :saveDisabled="!applicationStore.userRight('PRO.EDIT')"
        @saveClicked="saveProspectDetails">
        <template slot="append-left-buttons">
          <v-tooltip top style="z-index: 300">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <gat-button-menu
                  caption="Create email"
                  hint="Save prospect details and send email"
                  :menuItems="emailTemplateItems"
                  mainAction
                  btnColor="success"
                  useBottomPanelStyle
                  :disabled="emailTemplates && emailTemplates.length == 0"
                  @menuItemClick="onProspectEmailClick"
                  @subMenuItemClick="onProspectEmailClick"
                  icon="mdi-email" />
              </span>
            </template>
            Save prospect details and send email
          </v-tooltip>
        </template>
      </gat-bottom-panel>

      <email-generator
        ref="emailGenerator"
        :portcallId="callId"
        location="portcall"
        @isLoadingOverlay="isLoading = $event" />
    </gat-form>
    <div v-else>You don't have access to prospects!</div>
  </div>
</template>

<script lang="ts">
// eslint-disable-next-line import/no-cycle
import { apiGet, apiPut } from '@/store/api';
import GatUtils from '@/app-components/GatUtils';
import Vue from 'vue';
import GatButtonMenu from '@/plugins/gat-components/gatButtons/GatButtonMenu.vue';
import EmailGenerator from '@/app-components/EmailGenerator.vue';
import moment from 'moment';
import { useToolbarStore } from '@/store/toolbarStore';
import { useAppStatusStore } from '@/store/appStatusStore';
import { usePortcallStore } from '@/store/portcallStore';
import { useApplicationStore } from '@/store/applicationStore';
import { useHelperStore } from '@/store/helperStore';

export default Vue.extend({
  name: 'ProspectDetails',
  props: {
    callId: [String, Number],
    prospectId: [String, Number],
  },
  components: {
    GatButtonMenu,
    EmailGenerator,
  },
  setup() {
    const toolbarStore = useToolbarStore();
    const appStatusStore = useAppStatusStore();
    const portcallStore = usePortcallStore();
    const applicationStore = useApplicationStore();
    const helperStore = useHelperStore();
    return {
      applicationStore,
      toolbarStore,
      appStatusStore,
      portcallStore,
      helperStore,
    };
  },
  data() {
    return {
      hover: false,
      isValid: null,
      isLoading: true,
      prospectItem: {
        CHO_ID: undefined,
        CHO_NAME: '',
        CHO_SUBJECT: '',
        CHO_INSTRUCTIONS: '',
        CHO_PORTCALL_ID: undefined,
        CHO_HISTORY: '',
        CHO_LAST_UPDATED: '',
        CHO_LAST_UPDATED_BY: undefined as string | undefined,
        Updated: undefined,
      },
      orgProspectItem: {},
      prospectTemplates: [],
      saving: false,
      prospectHintAndInstructions: '',
      cursorPos: -1,
      localDateTime: '',
      emailTemplates: [],
    };
  },

  computed: {
    callDetails() {
      return this.portcallStore.callDetails;
    },
    applicationStatus() {
      return this.appStatusStore.getAppStatus;
    },
    emailTemplateItems() {
      const templates = [...this.emailTemplates];
      let result: any[] = [];
      const ignoreGroupMinCount = this.applicationStore.hasFeatureCode('IGNORE_DOCUMENT_GROUPING_MIN_COUNT');

      if (Array.isArray(templates) && templates.length > 0) {
        if (ignoreGroupMinCount ? true : templates.length > 10) {
          result = this.helperStore.emailTemplatesGroupedByLabels(templates, false);
        } else {
          result = templates.map((item: any) => ({
            caption: item.TITLE,
            icon: 'mdi-file-outline',
            ID: item.ID,
          }));
        }
      }

      return result;
    },
  },

  created() {},

  activated() {
    this.setBackNavigation();
    this.prospectItem = {
      CHO_ID: undefined,
      CHO_NAME: '',
      CHO_SUBJECT: '',
      CHO_INSTRUCTIONS: '',
      CHO_PORTCALL_ID: undefined,
      CHO_HISTORY: '',
      CHO_LAST_UPDATED: '',
      CHO_LAST_UPDATED_BY: undefined,
      Updated: undefined,
    };
    this.orgProspectItem = {};
    this.saving = false;
    if (this.callId) {
      this.getProspectHintAndInstructions(this.callId);
    }
    if (this.prospectId) {
      this.getProspectDetails(this.prospectId as number);
      this.appStatusStore.setAppStatusSelectedProspectId(this.prospectId);
    }
    if (this.callDetails && this.callDetails.SETUP_ID) {
      this.getProspectTemplates(this.callDetails.SETUP_ID);
    }
  },

  deactivated() {
    this.prospectItem = {
      CHO_ID: undefined,
      CHO_NAME: '',
      CHO_SUBJECT: '',
      CHO_INSTRUCTIONS: '',
      CHO_PORTCALL_ID: undefined,
      CHO_HISTORY: '',
      CHO_LAST_UPDATED: '',
      CHO_LAST_UPDATED_BY: undefined,
      Updated: undefined,
    };
    this.orgProspectItem = {
      CHO_ID: undefined,
      CHO_NAME: '',
      CHO_SUBJECT: '',
      CHO_INSTRUCTIONS: '',
      CHO_PORTCALL_ID: undefined,
      CHO_HISTORY: '',
      CHO_LAST_UPDATED: '',
      CHO_LAST_UPDATED_BY: undefined,
      Updated: undefined,
    };
    this.prospectHintAndInstructions = '';
    this.prospectTemplates = [];
    this.saving = false;
    this.emailTemplates = [];
    this.toolbarStore.setBackNavigation(undefined);
    this.appStatusStore.setAppStatusSelectedProspectId(null);
  },

  watch: {
    callId: {
      handler(val) {
        this.getProspectHintAndInstructions(val);
      },
      immediate: true,
    },
    prospectId: {
      handler(val) {
        this.getProspectDetails(val);
        this.appStatusStore.setAppStatusSelectedProspectId(val);
      },
      immediate: true,
    },
  },

  methods: {
    hasAgencySetting(value: string) {
      value.trim();
      let result = 0;
      const portcallAgency = this.callDetails.SETUP_ID; // Agency to which the current portcall belongs.
      if (portcallAgency) {
        const idx = this.applicationStore.agencySettings.findIndex((item: any) => item.ID == portcallAgency); // Find agencySettings for portcallAgency
        if (idx >= 0) {
          const agency = this.applicationStore.agencySettings[idx]; // Store all the agency settings.
          result = agency[value]; // Check the agency setting for the given argument.
        }
      }
      return result == 1;
    },
    getProspectDetails(prospectId: Number) {
      apiGet(`prospects/details/${prospectId}`).then((response: any) => {
        this.prospectItem = response;
        this.orgProspectItem = GatUtils.makeCopyViaJson(this.prospectItem);
        this.isLoading = false;
      });

      apiGet(`mail/templates/prospects/${this.callDetails.SETUP_ID}/${true}`).then((result: any) => {
        if (result) {
          this.emailTemplates = result;
        }
      });
    },
    async onProspectEmailClick(item: any) {
      (this.$refs.form as Vue & { validate: () => boolean }).validate();
      if (this.isValid && this.hasAgencySetting('TAB_PROSPECTS') && this.applicationStore.user.internal) {
        this.saving = true;
        this.isLoading = true;
        try {
          const applicationStatus = GatUtils.makeCopyViaJson(this.applicationStatus);
          this.prospectItem.CHO_LAST_UPDATED = moment().format('yyyy-MM-DD HH:mm:ss');
          this.prospectItem.CHO_LAST_UPDATED_BY = this.applicationStore.user.userNameLong?.toUpperCase();

          const result = await apiPut('/prospects/details', {
            value: this.prospectItem,
            orgValue: this.orgProspectItem,
          });
          this.prospectItem = result.payload;
          this.orgProspectItem = GatUtils.makeCopyViaJson(this.prospectItem);
          this.isLoading = false;

          const templateId = item.ID ?? item.item?.ID;
          const template = this.emailTemplates.find((entry: any) => entry.ID === templateId);
          if (this.callId && template) {
            await (
              this.$refs.emailGenerator as Vue & {
                generateEmail: (value: any, applicationStatus: object) => Promise<void>;
              }
            ).generateEmail(template, applicationStatus);
          }
        } finally {
          this.saving = false;
          this.isLoading = false;
        }
      } else {
        this.saving = false;
      }
    },
    saveProspectDetails() {
      (this.$refs.form as Vue & { validate: () => boolean }).validate();
      if (this.isValid && this.hasAgencySetting('TAB_PROSPECTS') && this.applicationStore.user.internal) {
        this.saving = true;
        this.isLoading = true;
        this.prospectItem.CHO_LAST_UPDATED = moment().format('yyyy-MM-DD HH:mm:ss');
        this.prospectItem.CHO_LAST_UPDATED_BY = this.applicationStore.user.userNameLong?.toUpperCase();

        apiPut('/prospects/details', {
          value: this.prospectItem,
          orgValue: this.orgProspectItem,
        }).then((result) => {
          this.prospectItem = result.payload;
          this.orgProspectItem = GatUtils.makeCopyViaJson(this.prospectItem);
          this.isLoading = false;

          // delayed for å ungå at dialog om data endret vises (changed property må rekke å settes)
          this.$nextTick(() => {
            this.$router.push({ name: 'prospectsList', params: { callId: this.callId as string } });
            this.saving = false;
          });
          this.saving = false;
        });
      } else {
        this.saving = false;
      }
    },
    setBackNavigation() {
      const result = [];
      if (this.callId) {
        result.push({ text: 'port call', href: `/call/${this.callId}` });
        result.push({ text: 'prospects', href: `/call/${this.callId}/prospects-list` });
      }
      this.toolbarStore.setBackNavigation(result);
    },
    getProspectHintAndInstructions(portCallId: String | Number) {
      apiGet(`prospects/instructions/${portCallId}`).then((response: any) => {
        this.prospectHintAndInstructions = response.payload;
      });
    },
    duplicateViaJson(obj: any) {
      let result = {};
      if (obj) {
        const jsonStr = JSON.stringify(obj);
        result = JSON.parse(jsonStr);
      }
      return result;
    },
    getProspectTemplates(agencyId: Number) {
      this.prospectTemplates = [];
      apiGet(`prospects/details/templates/${agencyId}`).then((response: any) => {
        this.prospectTemplates = response.payload;
      });
    },
    onProspectTemplateClick(e: any) {
      if (!e) return;
      let insertText = {};
      if (e.item && e.item.data) insertText = e.item.data;
      else if (e.data) insertText = e.data;
      else return;

      const textarea = (this.$refs.instructions as Vue & { $el: () => any }).$el.querySelector('textarea');
      if (!textarea) {
        this.cursorPos = 0;
        return;
      }

      if (textarea.selectionStart) this.cursorPos = textarea.selectionStart;
      else this.cursorPos = 0;

      const pos = this.cursorPos;

      const instructionText = this.prospectItem.CHO_INSTRUCTIONS ?? '';
      const before = instructionText.substring(0, pos);
      const after = instructionText.substring(pos, instructionText.length);
      this.prospectItem.CHO_INSTRUCTIONS = before + insertText + after;
    },
  },
});
</script>

<style scoped>
.prospect-details {
  /* v-main has an 8px margin on each side; reserve space for the fixed save bar. */
  box-sizing: border-box;
  height: calc(100vh - var(--prospect-header-height) - 16px);
  height: calc(100dvh - var(--prospect-header-height) - 16px);
  padding-bottom: calc(48px + env(safe-area-inset-bottom));
  overflow: hidden;
}

.prospect-form {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}

.prospect-header {
  flex: 0 0 auto;
}

.prospect-instructions {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: minmax(0, 1fr);
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;
}

.prospect-instruction-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}

.prospect-instruction-field ::v-deep .fieldSpacer {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.prospect-instruction-field ::v-deep .v-textarea {
  align-items: stretch;
  min-height: 0;
}

.prospect-instruction-field ::v-deep .v-input__control {
  height: 100%;
  min-height: 0;
  flex-wrap: nowrap;
}

.prospect-instruction-field ::v-deep .v-input__slot {
  flex: 1 1 0;
  align-items: stretch;
  min-height: 0;
}

.prospect-instruction-field ::v-deep .v-text-field__slot {
  flex-direction: column;
  min-height: 0;
}

.prospect-instruction-field ::v-deep .v-text-field__details {
  flex: 0 0 auto;
}

.prospect-instruction-field ::v-deep textarea {
  flex: 1 1 0;
  height: 0;
  min-height: 0;
  overflow-y: auto;
  resize: none;
}

@media (max-width: 959px) {
  .prospect-instructions {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(2, minmax(0, 1fr));
  }
}
</style>

<style>
/* Override Vuetify's document scrollbar only while this full-height page is mounted. */
html:has(.prospect-details) {
  overflow-y: hidden;
}
</style>
